import {getDefaultConfig} from "@/fit-components/toast/business";


export default {
    toast: getDefaultConfig(),
};
